import React, {
  useContext,
  createContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import { useAxios } from "../customHooks";
import { useAuth } from "./Auth-Context";
import { useModal } from "./Modal-Context";

const VideoContext = createContext();

const VideoProvider = ({ children }) => {
  const { response: videoResponse, isLoading: videoLoading, operation: fetchVideo } = useAxios();
  const {
    response: deleteVideoFromDBResponse,
    isLoading: deleteVideoFromDBLoading,
    operation: deleteVideoFromDBOperation,
  } = useAxios();
  const {
    response: postVideoDataResponse,
    isLoading: postVideoDataLoading,
    operation: postVideoDataOperation,
  } = useAxios();
  const { encodedToken, getCurrentUserOperation , responseUpdateUserProfile} = useAuth();
  const { setIsUploadVideoModal } = useModal();
  const [videos, setVideos] = useState([]);
  const [uploadVideoData, setUploadVideoData] = useState({
    title: "",
    description: "",
    thumbnail: "",
    video: "",
  });

  const getAllVideos = () => {
    fetchVideo({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_API}videos`,
    });
  };

  useEffect(() => {
    getAllVideos();
  }, []);

  useEffect(() => {
    getAllVideos();
  },[responseUpdateUserProfile])

  const uploadHandler = () => {
    const formData = new FormData();
    const videoDataArray = Object.keys(uploadVideoData);
    for (const element of videoDataArray) {
      formData.append(element.toString(), uploadVideoData[element]);
    }
    postVideoDataOperation({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_API}videos/uploadFiles`,
      data: formData,
      headers: { authorization: encodedToken },
    });
  };

  const deleteVideoHandler = (videoId) => {
    deleteVideoFromDBOperation({
      method: "delete",
      url: `${process.env.REACT_APP_BACKEND_API}videos/v/${videoId}`,
      headers: { authorization: encodedToken },
    });
  };

  useEffect(() => {
    if (postVideoDataResponse != null) {
      getAllVideos();
      setIsUploadVideoModal((prev) => !prev);
      setUploadVideoData(() => ({
        title: "",
        description: "",
        thumbnail: "",
        video: "",
      }));
      getCurrentUserOperation({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_API}users/get-user`,
        headers: { authorization: encodedToken },
      });
    }
  }, [postVideoDataResponse]);

  useEffect(() => {
    if (deleteVideoFromDBResponse != null) {
      getCurrentUserOperation({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_API}users/get-user`,
        headers: { authorization: encodedToken },
      });
      getAllVideos();
    }
  }, [deleteVideoFromDBResponse]);

  useEffect(() => {
    if (videoResponse !== undefined) {
      setVideos(videoResponse.data.docs);
    }
  }, [videoResponse]);

  const memoizedContextValue = useMemo(
    () => ({
      videos,
      setUploadVideoData,
      uploadVideoData,
      uploadHandler,
      postVideoDataLoading,
      deleteVideoHandler,
      deleteVideoFromDBResponse,
      deleteVideoFromDBLoading,
      videoLoading
    }),
    [
      videos,
      setUploadVideoData,
      uploadVideoData,
      uploadHandler,
      postVideoDataLoading,
      deleteVideoHandler,
      deleteVideoFromDBResponse,
      deleteVideoFromDBLoading,
      videoLoading
    ]
  );
  return (
    <VideoContext.Provider value={memoizedContextValue}>
      {children}
    </VideoContext.Provider>
  );
};

const useVideo = () => useContext(VideoContext);

export { VideoProvider, useVideo };
